import actions from './actions'

const detailInit = {
  fetching: false,
  data: undefined,
  error: false,
}

export default function customerDetail(state = detailInit, action) {
  switch (action.type) {
    case actions.DETAIL_FETCHING:
      return { ...state, fetching: true }
    case actions.DETAIL_FULFILLED:
      return { ...state, fetching: false, data: action.payload }
    case actions.DETAIL_REJECTED:
      return { ...state, fetching: false, error: true }
    case actions.DETAIL_CLEAR:
      return detailInit
    default:
      return state
  }
}
